import React from 'react'
import { Typography } from '@mui/material'
import { useSelector } from 'react-redux'
import { State } from '../types/state'
import Paper from '@mui/material/Paper'

const CommentedList = () => {
  const { commentedComments } = useSelector((state: State) => state.user)

  return (
    <div>
      {[...commentedComments]
        ?.sort((a, b) =>
          new Date(a?.createdAt) > new Date(b?.createdAt) ? -1 : 1
        )
        ?.map((comment, index) => (
          <Paper key={index}>
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                marginTop: '1vh',
                padding: '1vw'
              }}
            >
              <div>
                <Typography variant='h5'>{comment.content}</Typography>
                <Typography variant='subtitle2'>
                  {`to: ${comment.user.firstName} ${comment.user.lastName}`}
                </Typography>
                <Typography variant='subtitle1'>
                  {new Date(comment.createdAt).toLocaleString()}
                </Typography>
              </div>
            </div>
          </Paper>
        ))}
    </div>
  )
}

export default CommentedList
